import { BillingAddress } from "./redux/slices/checkout";

export function getFullName(firstName?: string, lastName?: string) {
  const first = (firstName || "").trim();
  const last = (lastName || "").trim();
  return first && last ? `${first} ${last}` : `${first}${last}`;
}

export function getFullNameFromBillingAddress(billingAddress: BillingAddress) {
  if (!billingAddress) {
    return undefined;
  }

  if (billingAddress.name) {
    return billingAddress.name;
  }

  return getFullName(billingAddress.firstName, billingAddress.lastName);
}
